<template>
	<div id="Loading" class="fullSize">

		<div id="fullStartLoading" class="fullSize"
		v-if="displayFullLoading()">

			<div id="loadingfull_band">
				<div id="loadingfull_title" class="title_bold">
					<div class="lds-ripple"><div></div><div></div></div>
					{{ App.lang.get('Loading') }} 
				</div>
				<div id="loadingfull_bar"
				v-bind:style=" { width: getCurrentFullLoadPercent() + '%' }"></div>

				<div id="loadingfull_percent" class="title_light">
					{{ Math.floor(getCurrentFullLoadPercent()) }} 
					<span class="dim">%</span>
				</div>

				
			</div>

			

		</div>

		<div id="loadingSubtle"
		v-if="displaySubtleLoading()">
			<div id="loadingSubtle_bar"
			v-bind:style=" { width: getCurrentSubtlePercent() + '%' }"></div>
		</div>

	</div>
</template>

<script>
export default {
	name: 'Loading',
	props: {
		App: Object
	},
	data : function() {
		return {
			
		}
	},
	mounted() {
		
	},
	created() {
	},
	methods : {

		getCurrentFullLoadPercent() {
			return this.App.LoadingManagerGlobal.fullLoad.percentCompleted

		},

		displayFullLoading() {

			return this.App.LoadingManagerGlobal.fullLoad.display
		},

		displaySubtleLoading() {
			return this.App.LoadingManagerGlobal.subtleLoad.display
		},

		getCurrentSubtlePercent() {
			return this.App.LoadingManagerGlobal.subtleLoad.percentCompleted
		}


	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}


</style>
